module.exports = __webpack_public_path__ + "static/media/Monitor.1eec9c2b.svg";